import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pagination-element" }


export default /*@__PURE__*/_defineComponent({
  __name: 'PaginationElement',
  props: {
    isActive: { default: 0 },
    page: { default: 1 }
  },
  emits: ["onClicked"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props
function onClicked() {
  emits('onClicked', props.page)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["content", { active: _ctx.isActive === _ctx.page }]),
      tabindex: "0",
      onClick: onClicked,
      onKeypress: onClicked
    }, _toDisplayString(_ctx.page), 35)
  ]))
}
}

})